<div class="{{localService.selectedLanguageCode}}" *ngIf="localService.languageContent">
  <app-business-deductive *ngIf="businessId != '' && businessId != '0'" [currentBusinessId]="businessId"
    [businesses]="localService.loggedMember.businesses"></app-business-deductive>
  <div class="banner center" style="max-width:1000px;" *ngIf="wrapper && wrapper.items && wrapper.items.length > 0">
    <div *ngIf="wrapper" class="custom_rows_body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
      <div class="row styled_row" *ngFor="let item of wrapper.items">
        <div class="col-12">
          <div class="notification_content">
            <a routerLink="/{{item.v4}}"
              class="material-icons button route_navigation">subdirectory_arrow_right</a>
            <span class="en notification_time">{{item.v2 | localDate : 'time'}}&nbsp;:&nbsp;</span>
            <div [innerHTML]="item.v1" style="float: left;"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-paging *ngIf="wrapper" [paging]="wrapper.paging" (onPagingRefreshed)="onLoad()"
    (onDateSelected)="onLoad()"></app-paging>
</div>